import { Routes, Route } from "react-router-dom";

import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import SeoManager from "./components/common/SeoManager";

import Home from "./pages/Home";
import ProductListing from "./components/ProductList";

import "./App.css";
import ProductDetails from "./pages/ProductDetails";
import CartStep from "./pages/Cart";
import AddressStep from "./pages/Address";
import AuthModal from "./components/auth/SignUp";
import { Toaster } from "react-hot-toast";
import LegalPage from "./pages/LegalPage";
import ContactPage from "./pages/ContactPage";
// import MiniatureProduct from "./pages/CustomProduct";

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#1e293b",
            color: "#fff",
            fontSize: "14px",
          },
          success: {
            style: { background: "#16a34a" },
          },
          error: {
            style: { background: "#dc2626" },
          },
        }}
      />
      <SeoManager />
      <Header />

      <main className="app-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<ProductListing />} />
          <Route path="/p/:productToken" element={<ProductDetails />} />
          {/* Keep previously shared links working while new links use /p/. */}
          <Route path="/product-details/:productToken" element={<ProductDetails />} />
          <Route path="/cart" element={<CartStep />} />
          <Route path="/address" element={<AddressStep />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route
            path="/terms-and-conditions"
            element={<LegalPage type="terms-and-conditions" />}
          />
          <Route
            path="/privacy-policy"
            element={<LegalPage type="privacy-policy" />}
          />
          <Route
            path="/return-policy"
            element={<LegalPage type="return-policy" />}
          />
          {/* <Route path="/custom" element={<MiniatureProduct />} /> */}
          <Route path="/login" element={<AuthModal />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}

export default App;
